import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Navigate } from "react-router-dom";
import PrivateRoutes from "./Components/PrivateRoutes/PrivateRoutes";
import { RoutesWrapper } from "./Components/RoutesWrapper/RoutesWrapper";
import RecordForm from "./Pages/RecordForm/RecordForm";
import SignIn from "./Pages/SignIn/SignIn";
import NotFound from "./Pages/NotFound/NotFound";
import PaymentStatus from "./Pages/PaymentStatus/PaymentStatus";
import RecordHistory from "./Pages/RecordHistory/RecordHistory";
import AccessLinkStatus from "./Pages/AccessLinkStatus/AccessLinkStatus";
import ViewLinkStatus from "./Pages/ViewLinkStatus/ViewLinkStatus";
function App() {
	return (
		<div className="App">
			<Router>
				<RoutesWrapper>
					<Route element={<PrivateRoutes />}>
						<Route path="/" element={<Navigate to="/dashboard" replace />} />
						<Route path="dashboard" element={<RecordForm />} />
						<Route path="payment-status" element={<PaymentStatus />} />
						<Route path="record-history" element={<RecordHistory />} />
					</Route>

					{/* <Route path="/sign-in" element={<SignIn />} /> */}
					<Route path="/access-link-status" element={<AccessLinkStatus />} />
					<Route path="/view-link-status" element={<ViewLinkStatus />} />
					{/* <Route path="/sign-up" element={<SignUpPage />} /> */}
					<Route path="*" element={<NotFound />} />
				</RoutesWrapper>
			</Router>
		</div>
	);
}

export default App;
